import { TRANSITION_DELAYS } from '../constants';

const processElementChildren = (element, selector, delay) => {
	const isInEditMode = document.body.classList.contains('editing-mode');
	const elements = element.querySelectorAll(selector);
	if (elements.length > 0) {
		elements.forEach((el, index) => {
			setTimeout(() => {
				el.classList.add('complete');
			}, isInEditMode ? 0 : delay || (index + 1) * TRANSITION_DELAYS.xs);
		});
	}
};

export default processElementChildren;
